import { HttpClient  } from '@angular/common/http';
import {inject, Injectable} from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { EncriptionService } from './encription.service';

export interface IStorageItem{
    idToken: string,
    clientId: string,
    expiry: number,
    value?: string,
}

@Injectable({
    providedIn: 'root'
})
export class AuthService {

    storageKey = 'token';
    private http = inject(HttpClient);
    private encryptinService = inject(EncriptionService);

    constructor() {}

    public getToken(reCaptcha: string): Observable<any> {
        return this.http.post<any>(environment.tokenAPI, {reCaptcha: reCaptcha});
    }

    async getCredentials() {
        const clientSecret = await this.encryptinService.getClientSecret();
        const password = await this.encryptinService.getPassword();
        return {clientSecret, password};
    }

    setWithTTL(idToken:string, clientId: string, ttl:number):IStorageItem {
        const now = new Date()

        const item:IStorageItem = {
            idToken: idToken,
            clientId: clientId,
            expiry: now.getTime() + (ttl * 1000),
        }

        localStorage.setItem(this.storageKey, JSON.stringify(item));
        return item;
    }
    expiryToken() {

        localStorage.removeItem(this.storageKey);

    }

    getWithTTL():IStorageItem | null {
        const storageItem = localStorage.getItem(this.storageKey)
        if (!storageItem)
            return null;

        const item:IStorageItem = JSON.parse(storageItem)

        if ( item.value !== undefined ){
            return null;
        }

        const now = new Date()

        if (now.getTime() >= item.expiry) {
            localStorage.removeItem(this.storageKey)
            return null;
        }

        return item;
    }
}
